import styled from "styled-components";
import { Space } from "@tvg/design-system";

export const DefaultContainer = styled.div<{ space: Space }>`
  display: flex;
  flex-direction: column;
  gap: ${({ space }) => space["space-4"]};
`;

export const BottomSpacer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;
